export default "__VITE_ASSET__DkTi3j4M__"